import React, { Component } from "react";

export default class Services extends Component {
  render() {
    return (
      <section id="platform" className="section-platform">
        <div className="row">
          <div className="col-sm-12">
            <h2>OUR PLATFORM</h2>
            <h3>
              Catch the wave of opportunity with our secure, robust, and
              sustainable mobile solutions.
            </h3>
          </div>
        </div>
        <div className="row services-row">
          <div className="services-image-box">
            <img
              src={require("../../assets/img/platform2.png")}
              alt="Smilestein app on iPhone"
            />
          </div>
          <div className="services-box">
            <div className="services-step">
              <p className = "services-title">BENEFITS</p>
              <p>
                Versatile software
                <br />
                Sustainable platform
                <br />
                Foundation for growth
                <br />
                Build audience communication
                <br />
                Mobile engagement
                <br />
                Analytical tracking
                <br />
                Extensive code libraries
                <br />
                Agile development
                <br />
                Applicable across industries
                <br />
                Extensive server technologies
                <br />
                Solutions for the Internet of Things
                <br />
              </p>
            </div>
          </div>
        </div>
      </section>
    );
  }
}
